// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"f7158c22","232":"c25eee15","237":"f874c1df","357":"93156a49","526":"5c78b146","872":"15f79e21"}[chunkId] + ".chunk.js";
};